import '.d8{position:fixed;}.ssr-plugin'
import '.ae{z-index:2;}.ssr-plugin'
import '.b9{inset:0px;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.ar{pointer-events:none;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.cf{top:0px;}.ssr-plugin'
import '.ag{left:0px;}.ssr-plugin'
import '.be{right:0px;}.ssr-plugin'
import '.bv{display:none;}.ssr-plugin'
import '.k{height:100%;}.ssr-plugin'
import '.go{inset:0px;}.ssr-plugin'
import '.fc{z-index:1;}.ssr-plugin'
import '.dz{top:50%;}.ssr-plugin'
import '.e0{transform:translateY(-50%);}.ssr-plugin'
import '.e1{right:0px;}.ssr-plugin'
import '.e2{left:0px;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.e3{height:72px;}.ssr-plugin'
import '.e4{width:72px;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.ab{border-radius:50%;}.ssr-plugin'
import '.e5{border:none;}.ssr-plugin'
import '.bi{max-width:480px;}.ssr-plugin'
import '.g0{margin-top:48px;}.ssr-plugin'
import '.b5{text-align:center;}.ssr-plugin'
import '.gp{padding:48px;}.ssr-plugin'
import '.gq{padding-right:102px;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.bz{gap:24px;}.ssr-plugin'
import '.gr{text-align:right;}.ssr-plugin'
import { useState, useEffect } from 'react'
import { styled } from 'inlines'
import { Video } from 'excelsis-video'
import { colors } from '../utils/colors.js'
import { Layout } from './Layout.js'
import { Button } from './Button.js'
import { IconButton } from './IconButton.js'
import { MenuVotingRegion } from './MenuVotingRegion.js'
import { Logo } from '../assets/svg/Logo.js'
import { Icon } from '../assets/icons/index.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { SelectLanguageModal } from './SelectLanguageModal.js'
import { SelectVotingRegionModal } from './SelectVotingRegionModal.js'
import { Meter } from './Meter.js'
import { MOBILE, TABLET } from '../utils/breakpoints.js'
import { Background } from './Background.js'
import { useDictionary } from '../hooks/useDictionary.js'

type RecapVideoProps = {
  src: string
  setWatchedRecap: (x: boolean) => void
}

export const RecapVideo = ({ src, setWatchedRecap }: RecapVideoProps) => {
  const [remainingTime, setRemainingTime] = useState(0)
  const [progress, setProgress] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const [hasEnded, setHasEnded] = useState(false)

  const [openLangMenu, setOpenLangMenu] = useState(false)
  const [openLangSelectModal, setOpenLangSelectModal] = useState(false)
  const [openRegionModal, setOpenRegionModal] = useState(false)

  const {
    recapProceedToVoting,
    recapStartVideo,
    continueButton,
    recapWatchVideo,
  } = useDictionary()

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  if (hasEnded) setWatchedRecap(true)

  return (
    <div className="d8 ae b9 e f"
      style={{
        background: colors.secondary,}}
    >
      <Layout
        style={{
          justifyContent: 'flex-end',
          padding: 0,
          [TABLET]: {
            padding: '48px',
            justifyContent: 'center',
          },
          [MOBILE]: {
            padding: '24px',
          },
        }}
      >
        <Video
          // @ts-ignore
          playsInline
          // @ts-ignore
          onEnded={() => {
            setHasEnded(true)
            setIsPlaying(false)
          }}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onTimeUpdate={(e: React.SyntheticEvent<HTMLVideoElement>) => {
            const video = e.currentTarget
            const remaining = Math.ceil(video.duration - video.currentTime)
            setRemainingTime(remaining)
            if (video.duration) {
              setProgress((video.currentTime / video.duration) * 100)
            }
          }}
          autoPlay={!hasEnded}
          src={src}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: 0,
            zIndex: 0,
            '& video': {
              objectFit: 'cover',
            },
            [TABLET]: {
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '24px',
              maxWidth: '696px',
              margin: '0 auto',
              '& video': {
                zIndex: 1,
              },
            },
          }}
        >
          <Video.SoundButton
            style={{
              position: 'absolute',
              top: 52,
              right: 48,
              width: 32,
              height: 32,
              borderRadius: 16,
              zIndex: 1,
              background:
                'linear-gradient(0deg, var(--White, rgba(255, 255, 255, 0.25)) 0%, var(--White, rgba(255, 255, 255, 0.25)) 100%)',
              [TABLET]: {
                top: '16px',
                right: '16px',
              },
              [MOBILE]: {
                top: '12px',
                right: '12px',
              },
            }}
            soundOffIcon={<Icon type="volumeOffIcon" />}
            soundOnIcon={<Icon type="volumeIcon" />}
          />
          <styled.div className="a6 ar m cf ag be"
            style={{
              height: isPlaying ? '25vh' : '100vh',
              background: !isPlaying
                ? transparentColor(colors.secondary, 0.75)
                : `linear-gradient(180deg, ${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,
              [TABLET]: {
                height: '25vh',
                background: `linear-gradient(180deg, ${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,
              },
            }}
          />
          {!isPlaying && (
            <styled.div className="bv ar m k a6 go fc"
              style={{
                background: transparentColor(colors.secondary, 0.5),
                [TABLET]: {
                  display: 'block',
                },
              }}
            />
          )}
          {!isPlaying && (
            <div className="a6 dz e0 e1 e2 e w cy f fc"
              style={{
                pointerEvents: hasEnded ? 'auto' : 'none',}}
            >
              {!hasEnded && (
                <styled.button className="e3 e4 e w cy ap ab ar e5"
                  style={{
                    background: colors.white,
                    '&svg': { width: '90px' },
                    [MOBILE]: {
                      height: '56px',
                      width: '56px',
                    },
                  }}
                >
                  <Icon
                    type="playIcon"
                    color={colors.secondary}
                    style={{ width: 34, height: 34 }}
                  />
                </styled.button>
              )}
              <styled.p className="bi g0 b5"
                style={{
                  [TABLET]: {
                    display: 'none',
                  },
                }}
              >
                {hasEnded ? recapProceedToVoting : recapStartVideo}
              </styled.p>
              {hasEnded && (
                <Button
                  style={{
                    marginTop: 32,
                    [TABLET]: { display: 'none' },
                  }}
                  trailIcon={
                    <Icon type="forwardIcon" color={colors.secondary} />
                  }
                  onClick={() => setWatchedRecap(true)}
                >
                  {continueButton}
                </Button>
              )}
            </div>
          )}
          {isPlaying && (
            <Video.TimeLine
              style={{
                display: 'none',
                pointerEvents: 'none',
                position: 'absolute',
                width: 'calc(100% - 24px)',
                zIndex: 1,
                bottom: 6,
                left: 12,
                right: 12,
                [TABLET]: {
                  display: 'block',
                },
                [MOBILE]: {
                  bottom: '0px',
                },
              }}
            />
          )}
        </Video>

        <styled.p className="bi g0 bv b5"
          style={{
            [TABLET]: {
              display: 'block',
            },
            [MOBILE]: {
              marginTop: '20px',
            },
          }}
        >
          {hasEnded ? recapProceedToVoting : recapStartVideo}
        </styled.p>

        {hasEnded && (
          <Button
            style={{
              display: 'none',
              [TABLET]: {
                display: 'flex',
                marginTop: 24,
              },
              [MOBILE]: {
                marginTop: 16,
              },
            }}
            trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
            onClick={() => setWatchedRecap(true)}
          >
            {continueButton}
          </Button>
        )}

        <styled.nav className="a6 cf ag be gp gq ao w"
          style={{
            display: !isPlaying ? 'none' : 'flex',
            [TABLET]: {
              display: 'flex',
              padding: '24px',
            },
          }}
        >
          <IconButton
            id="#menu-button"
            icon={<Icon type="globeIcon" style={{ pointerEvents: 'none' }} />}
            onClick={() => {
              setOpenLangMenu(!openLangMenu)
            }}
          />
          <Logo
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
            width={95}
            height={32}
          />
          <div className="e w bz"
          >
            <styled.p className="subtext gr"
              style={{
                [TABLET]: {
                  display: 'none',
                },
              }}
            >
              {recapWatchVideo}
            </styled.p>
            <Meter value={progress} style={{ maxWidth: 72 }} />
          </div>
        </styled.nav>
      </Layout>
      {openLangMenu && (
        <MenuVotingRegion
          id="#menu-button"
          setOpen={setOpenLangMenu}
          setOpenLangSelectModal={setOpenLangSelectModal}
          setOpenRegionModal={setOpenRegionModal}
          style={{
            top: 96,
            left: 48,
            [MOBILE]: {
              top: '56px',
              left: '16px',
              right: '16px',
              maxWidth: 'unset',
              width: 'auto',
            },
          }}
        />
      )}
      {openLangSelectModal && (
        <SelectLanguageModal setModal={setOpenLangSelectModal} />
      )}
      {openRegionModal && (
        <SelectVotingRegionModal setModal={setOpenRegionModal} />
      )}
      <Background type="onboarding" motion={1} style={{ background: 'red' }} />
    </div>
  )
}
